:root {
  --logo-filter: none;
}

[data-mantine-color-scheme="dark"] {
  --logo-filter: brightness(0) invert(1);
}

.rootContainer {
  background-color: light-dark(var(--mantine-color-body), var(--mantine-color-primaryDark-8));
  border-radius: var(--mantine-radius-md);
}

.link {
  text-decoration: none;
}

.card {
  background-color: light-dark(var(--mantine-color-body), var(--mantine-color-primaryDark-8));
  border-radius: var(--mantine-radius-md);
}

.link .card {
  cursor: pointer;
}

.link .card:hover {
  background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-primaryDark-7));
}

.logo {
  filter: var(--logo-filter);
  display: block;
  margin: 0 auto;
  max-width: 100%;
  max-height: 100%;
}

.logoContainer {
  padding: 0.3em;
  border-radius: var(--mantine-radius-sm);
  background-color: light-dark(
    var(--mantine-color-primaryDark-0),
    var(--mantine-color-secondary-7)
  );
  display: flex;
  align-items: center;
  justify-content: center;
}
